module.exports = __webpack_public_path__ + "img/logo.60501f2f.svg";